import { globalFocusKey } from "@/config/focus-key";
import type { ChannelGroupId } from "@sunrise/backend-types-core";

export function channelGroupIdToFocusId(
  channelGroupId: ChannelGroupId,
): string {
  return `${globalFocusKey.channelGroups}-${channelGroupId}`;
}
